// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3q04M","title":"ClientReferral_title__3umVc","itemText":"ClientReferral_itemText__14NcK"};